import { useState, useEffect } from 'react';
import { Wine, Mail } from 'lucide-react';

const StickyCtaBar = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!visible) return null;

  return (
    <div
      data-testid="sticky-cta-bar"
      className="fixed bottom-0 left-0 right-0 z-40 bg-gradient-to-r from-[#1a1a2e] to-[#16213e] border-t border-amber-500/30 shadow-2xl backdrop-blur-sm py-2 px-3 md:py-2.5 md:px-6 flex items-center justify-between gap-2 text-white"
    >
      <div className="hidden md:flex items-center gap-2 text-amber-300 text-sm font-medium">
        <Wine className="w-4 h-4" />
        <span>Wine Tasting €14 | Walk in Mon-Sat</span>
      </div>
      <div className="flex items-center gap-2 w-full md:w-auto justify-center md:justify-end">
        <a
          href="mailto:consultas@brunchi.shop?subject=Brunchi.shop%20enquiry"
          data-testid="cta-email"
          className="flex items-center gap-1.5 bg-blue-600 hover:bg-blue-700 text-white text-xs font-bold px-3 py-2 rounded-full transition-colors"
        >
          <Mail className="w-3.5 h-3.5" />
          Email Us
        </a>
        <a
          href="/wine-tasting"
          data-testid="cta-tasting"
          className="flex items-center gap-1.5 bg-amber-600 hover:bg-amber-700 text-white text-xs font-bold px-3 py-2 rounded-full transition-colors"
        >
          <Wine className="w-3.5 h-3.5" />
          Wine Tasting €14
        </a>
      </div>
    </div>
  );
};

export default StickyCtaBar;
